import type { ParsedPublicMessage } from '@module/types/centrifuge/messageTypes';
import { type CastResumeMessage, isCastResumeMessage } from '@module/types/centrifuge/public-message/blindMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class CastResumeHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<CastResumeMessage>) {}

  canHandle(payload: ParsedPublicMessage): boolean {
    return isCastResumeMessage(payload);
  }

  handle(payload: CastResumeMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.startRetry?.();
  }
}
